// Report & Get Paid -- unified home for the reimbursement money path that
// used to be two separate left-menu pages (State Reporting + Draws). The two
// underlying pages are unchanged and self-contained; this presents them as
// tabs under one destination so "file to the state" and "draw the money"
// live in one place. Tab driven by ?tab= so the old-route redirects
// (/state-reporting, /draws) and deep links land on the right tab.
import { useSearchParams } from 'react-router-dom';
import StateReportingPage from './StateReportingPage';
import DrawsPage from './DrawsPage';

type TabKey = 'state' | 'draws';

const TABS: { key: TabKey; label: string; sub: string }[] = [
  { key: 'state', label: 'State Reporting', sub: 'File everything BEAD requires to the state (Ready.net)' },
  { key: 'draws', label: 'Draws',           sub: 'Milestone reimbursement drawdown' },
];

export default function ReportGetPaidPage() {
  const [sp, setSp] = useSearchParams();
  const raw = sp.get('tab');
  const active: TabKey = (TABS.some(t => t.key === raw) ? raw : 'state') as TabKey;

  const setTab = (k: TabKey) => {
    const next = new URLSearchParams(sp);
    next.set('tab', k);
    setSp(next);
  };

  return (
    <div>
      <div style={{ padding: '18px 24px 0' }}>
        <div style={{
          fontSize: 11, fontWeight: 700, letterSpacing: 0.6,
          textTransform: 'uppercase', color: '#64748b', marginBottom: 8,
        }}>Report &amp; Get Paid</div>
        <div style={{
          display: 'flex', gap: 4,
          borderBottom: '1px solid var(--border,#e2e8f0)',
        }}>
          {TABS.map(t => {
            const on = t.key === active;
            return (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                title={t.sub}
                style={{
                  padding: '9px 16px',
                  border: 'none',
                  borderBottom: on ? '2px solid #0f172a' : '2px solid transparent',
                  background: 'transparent',
                  color: on ? '#0f172a' : '#64748b',
                  fontSize: 14,
                  fontWeight: on ? 700 : 600,
                  cursor: 'pointer',
                  marginBottom: -1,
                }}
              >
                {t.label}
              </button>
            );
          })}
        </div>
      </div>

      {active === 'state' && <StateReportingPage />}
      {active === 'draws' && <DrawsPage />}
    </div>
  );
}
